function hero() {
  return (
    <main>
       <section className="hero p-5">
         <div className='container'>
            <div className='row'>
              <h1 className="header-line">MarkdownMagic</h1>
            </div>
         </div>
       </section>
     </main>
  );
}

export default hero;
